import Container from "@/components/layout/Container";

export default function ContactIntro() {

  return (

    <div className="border-b border-border-soft bg-bg-light">

      <Container>

        <div className="
          flex flex-col gap-2
          py-5 md:py-6
        ">

          {/* 🔥 BREADCRUMB */}
          <div className="flex items-center gap-2 text-[12px] text-text-muted">

            <a href="/" className="hover:text-text-primary transition">
              Home
            </a>

            <span>/</span>

            <span className="text-text-primary font-medium">
              Contact
            </span>

          </div>

          {/* 🔥 TITLE */}
          <h1 className="
            text-[20px] md:text-[26px]
            font-semibold
            text-text-primary
            leading-snug
            max-w-[30ch]
          ">
            Discuss your property with our team  
            and explore its full revenue potential
          </h1>
        </div>

      </Container>

    </div>
  );
}